import { Button, Modal } from "antd";
import dayjs from "dayjs";

import styles from "@/components/DowntimeModal/DowntimeModal.module.css";

interface DowntimeModalProps {
  open: boolean;
  startTime?: string;
  endTime?: string;
  onClose: () => void;
}

const formatTime = (value?: string): string => {
  if (!value) return "-";
  const parsed = dayjs(value, "HH:mm");
  return parsed.isValid() ? parsed.format("h:mm A") : value;
};

const DowntimeModal: React.FC<DowntimeModalProps> = ({ open, startTime, endTime, onClose }) => (
  <Modal open={open} onCancel={onClose} footer={null} centered width={420} className={styles.modal}>
    <div className={styles.title}>Service Temporarily Unavailable</div>
    <div className={styles.description}>
      The app is currently undergoing scheduled maintenance from {formatTime(startTime)} to{" "}
      {formatTime(endTime)}. We apologise for the inconvenience caused. Thank you for your
      understanding. We will be back online soon.
    </div>

    <Button className={styles.closeButton} onClick={onClose}>
      Ok
    </Button>
  </Modal>
);

export default DowntimeModal;
